import React from "react";
import DedicatedIntegrationPoolShiftTable from "./DedicatedIntegrationPoolShiftTable";

const ActiveShiftsTab = ({data, loading, currentPage, setCurrentPage}) => {
    return (
        <DedicatedIntegrationPoolShiftTable
            loading={loading}
            data={data?.rows || []}
            dataCount={data?.dataCount}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            hideActualShiftColumn={true}
            hideDurationColumn={true}
        />
    );
};

export default ActiveShiftsTab;
